<template>
  <div class="b-filter">
    <div v-if="filtersData.title" class="b-filter__title" >{{ filtersData.title }}</div>
    <div>
      <ul class="b-filter__items">
        <li
          v-for="filter in filtersData.filters"
          :key="filter.id"
          class="b-filter__item"
          :class="selectedFilter === filter.id ? 'active' : ''">
          <label v-if="filter.type === 'duration'">
            <input
             v-model="selectedFilter"
              type="radio"             
              name="filters"
              :value="filter.id"
              @change="changeDuration" />
            {{ filter.label }}
          </label>

          <double-datepicker
            v-if="filter.type === 'datepicker'"
            :label="filter.label"
            :from-label="fromLabel"
            :to-label="toLabel"
            :date-from="dateFrom"
            :date-to="dateTo"
            :re-init-pickers="reInitPickers"
            @changed-date="getDates"></double-datepicker>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import DoubleDatepicker from '../DoubleDatepicker.vue'

export default {
  components: { DoubleDatepicker },
  props: {
    reInitPickers: {
      required: true,
      type: Boolean,
    },
    filtersData: {
      required: true,
      type: Object,
    },
    activeFilter: {
      required: true,
      type: String,
    },
    fromLabel: {
      type: String,
      default: '',
    },
    toLabel: {
      type: String,
      default: '',
    },
    dateFrom: {
      type: String,
      default: '',
    },
    dateTo: {
      type: String,
      default: '',
    },
  },
   emits: ['changed-duration', 'changed-date'],
  data() {
    return {
      selectedFilter: '',
    }
  },
  watch: {
    activeFilter(newVal) {
      this.selectedFilter = newVal
    },
  },
  mounted() {
    this.elem = jQuery(this.$el)

    this.selectedFilter = this.activeFilter
  },
  methods: {
    changeDuration() {
      this.$emit('changed-duration', this.selectedFilter)
    },
    getDates(dates) {
      this.$emit('changed-date', dates)
    },
  },
}
</script>
